import { styled } from '@cp/ds/src/theme/styled';
import { Box } from '@cp/ds/src/components/box';

export const StepWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  flexGrow: 1,
});
